// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-4f890b72]{display:flex;flex-direction:row;background:#f5f5f6;padding:4px 12px;margin:8px 2px 2px 2px;border:3px solid #EEE;border-radius:10px 10px 0 0;text-align:center}.label[data-v-4f890b72]{font-size:14px;font-weight:500;color:#999;margin:2px auto 0 auto}@media (max-width: 900px){.label[data-v-4f890b72]{font-size:11px !important}}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
